import React, { Component } from 'react';
import { StyleSheet, Text, View } from 'react-native';
import Theme from '../../theme';
import {  mappedSkillLevelIcons } from '../../ui/components/SkillLevelList';
import { getSkillLevelText } from '../../utils';
import { defaultScale } from '../../utils/scaling';

class SkillLevel extends Component<any, any> {
  public render() {
    const { skillLevel, t } = this.props;
    if (!skillLevel) {
      return (
        <View>
           <Text style={styles.goal}>{t('pleaseSelectASkillLevel')}</Text>
        </View>
      );
    }
    return (
      <View style={{ flexDirection: 'row' }}>
        <View>{mappedSkillLevelIcons[skillLevel]()}</View>
        <Text style={styles.goal}>{getSkillLevelText[skillLevel]}</Text>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  containerStyle: {
    flex: 1,
    paddingTop: defaultScale(20),
    flexBasis: '0%',
  },
  radioContainer: {
    justifyContent: 'flex-start',
  },
  goal: {
    ...Theme.textStyle.bodyCopyMed,
    color: Theme.BLACK,
    marginLeft: defaultScale(10),
  },
});

export default SkillLevel;
